whenAvailable('$', () => {
  $(function() {
      var $formCategories = $('.form-categories');
      var $formSubcategories = $('.form-subcategories');
      var $formCategoriesWrapper = $formCategories.find('.option-wrapper');
      var $formSubcategoriesWrapper = $formSubcategories.find('.option-wrapper');
      var $formSubcategoriesTitle = $('.form-subcategory-title');
      var $formFAQ = $('.form-faq');
      var $formMain = $('.form-main');

      var $contactForm = $('#contact_form');
      var $submitBtn = $('#form_submit');

      const country_full_name = {
          SG: 'singapore'
          , MY: 'malaysia'
          , KR: 'south_korea'
          , AU: 'australia'
          , NZ: 'new_zealand'
          , UK: 'united_kingdom'
          , US: 'united_states_of_america'
          , CA: 'canada'
      }

      const thisCountry = country_full_name[getCookie('_geo_country_code')] ?? '';

      var thisStore = $formMain.data('store-code');
      var selectedCategory = '';
      var selectedSubcategory = '';
      var selectedQuestion = '';
      var isKorea = false;
      var formID = '';

      var $responseModal = $('#response_modal');
      var $responseError = $('.response-error');
      var $responseServerError = $('.response-server-error');
      var $responseSuccess = $('.response-success');

      // MODAL
      function responseSuccess(){
          $responseModal.removeClass('success error').addClass('success');
          whenAvailable('bootstrap', function() { $responseModal.modal('show'); });
      }

      function responseError() {
          $responseModal.removeClass('success error').addClass('error');
          whenAvailable('bootstrap', function() { $responseModal.modal('show'); });
      }

      function responseServerError() {
          $responseModal.removeClass('success error ').addClass('server-error');
          whenAvailable('bootstrap', function() { $responseModal.modal('show'); });
      }

      function responseHide() {
          $responseSuccess.add($responseError);
          $responseModal.removeClass('success error').addClass('error');
          whenAvailable('bootstrap', function() { $responseModal.modal('hide'); });
      }


      // INIT
      function contactFormInit() {

          // Generate List of Countries
          $.ajax({
              url: 'https://beans.secretlab.co/api/contact_fields_options',
              method: 'POST',
              data: { 'fields[]': 'country' }
          }).done(function (response) {
              var countries = response.payload.country;
              $.each(countries, function(key, value) {
                  const selected = thisCountry === key ? 'selected' : ''

                  $('#country').append(`<option value='${key}' ${selected}>${value}</option>`);
              });
          });

          // Run KR Specific Code
          if (thisStore == 'KR') {
              isKorea = true;

              var checkboxTarget = '.terms-kr .field.stack';

              $(checkboxTarget).change(function() {
                  if ($(this).hasClass('all')) {
                      if ($(checkboxTarget + '.all .input-checkbox')[0].checked) { $(checkboxTarget + '.single .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.single .input-checkbox').prop('checked', false); }
                  } else {
                      var allChecked = true;
                      $(checkboxTarget + '.single .input-checkbox').each(function(i,v) { if (!this.checked) { allChecked = false; } });
                      if (allChecked == true) { $(checkboxTarget + '.all .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.all .input-checkbox').prop('checked', false); }
                  }
              });
          }

          // Initialize datepicker for Delivery Date field
          $('.datepicker').datepicker({ dateFormat: 'yy-mm-dd' });

          // Check URL for Anchor
          var url_hash = document.location.hash;
          if (url_hash != undefined) {
              selectedCategory = url_hash.replace('#', '').split('-')[0];
              selectedCategory = selectedCategory.charAt(0).toUpperCase() + selectedCategory.slice(1);
              selectedSubcategory = url_hash.replace('#', '').split('-')[1];

              $('.form-category').each(function(){
                  if ($(this).data('category') == selectedCategory) {
                      $formCategoriesWrapper.add(`[data-category="${selectedCategory}"]`).addClass('active');
                      $('[data-category]').not(`[data-category="${selectedCategory}"]`).slideUp();

                      initalizeSubcategories(selectedCategory);

                      if ((selectedSubcategory != undefined) && (selectedSubcategory < formOptions[selectedCategory].length)) {
                          $formSubcategoriesWrapper.add(`[data-subcategory="${selectedSubcategory}"]`).addClass('active');
                          $('[data-subcategory]').not(`[data-subcategory="${selectedSubcategory}"]`).slideUp();
                          selectedQuestion = $(`[data-subcategory="${selectedSubcategory}"]`).find('.col').text().trim();

                          initalizeForm(selectedCategory, selectedSubcategory);
                      }
                  }
              });
          }

          // Autofill fields based on field 'name'
          // e.g. ?name=John%20Doe&shopify_order_number=12345#warranty-1
          var sPageURL = window.location.search.substring(1);
          var sURLVariables = sPageURL.split('&');
          var sParameterName;

          if (sURLVariables != '') {
              for (var i = 0; i < sURLVariables.length; i++) {
                  sParameterName = sURLVariables[i].split('=');
                  if ($(`[name=${sParameterName[0]}]`).length) {
                      $(`[name=${sParameterName[0]}]`).val(decodeURI(sParameterName[1]));
                  }
              }
          }
      }

      whenAvailable('bootstrap', function() { $responseModal.modal({ show: false }); });
      contactFormInit();


      // FORM FUNCTIONS
      function clearFields() {
          // Reset fields/forms to default values
          $contactForm.show().removeClass('was-validated'); // Unhide contact form by default
          $('input:not([type="hidden"]):not([type="radio"]), select, textarea').val('').prop('checked', false).removeClass('is-invalid'); // Empty/Reset all fields except hidden and radio buttons
          $('.form-type').val('').prop('disabled', true); // Empty/Reset Zendesk-required fields
          $('#productType1, #preorder1, #packaging_yes').prop('checked', true); // Reset radio buttons

          if ($(`#country option[value="${thisCountry}"]`).length) { $('#country').val(thisCountry); }
          else { $('#country').val(''); }
      }

      function formFieldsReset() {
          $('.dynamic-field, .hidden-element, .dynamic-label').hide(); // Hide all dynamic and hidden elements as default
          $('.dynamic-label.label-1').show(); // Show the first dynamic label as default

          $('.dynamic-field').each(function() {
              var field = $(this).find('input, select, textarea');
              field.attr('placeholder', field.attr('data-og-placeholder')); // Reset placeholder based on stored data
              field.attr('required', false).prop('disabled', true); // Remove required attribute
          });

          clearFields();
      }

      // This function is used to display and modify any fields in the contact form.
      // Ensure that the field is wrapped in a container with an ID.
      function formFieldShow(id, isRequired, newPlaceholder, enabledLabel=false) {
          // variable initialisation
          var $id = $(`#${id}`);
          var field = $id.find('input, select, textarea');
          var placeholder = field.attr('placeholder');
          // set placeholder & required to empty
          field.attr('placeholder', '')
          field.removeAttr('required');

          if (isRequired) {
              if (id == 'fieldFiles') {
                  $('#attachments').attr('required', true);
              } else {
                    // if placeholder is empty, set to default placeholder
                    if (!placeholder) {
                        field.attr('placeholder', localization.required);
                        field.attr('required', true);
                    } else {
                        field.attr('placeholder', placeholder);
                        field.attr('required', true);
                    }
              }
          }

          if(enabledLabel) {
              $id.find('label').html(newPlaceholder)
          }

          if (id == 'fieldFiles') { $('#attachments').prop('disabled', false); }
          else { field.prop('disabled', false); }
          $id.show();
      }

      function formFieldHide(id) {
          var $id = $(`#${id}`);
          var field = $id.find('input, select, textarea');
          var placeholder = field.attr('data-og-placeholder');
          field.attr('required', false).prop('disabled', true).attr('placeholder', placeholder);
          $id.hide();
      }

      function initalizeSubcategories(category) {
          $formSubcategoriesWrapper.empty();

          formOptions[category].forEach(function(v, i){
              var changeText = $('.option-selector-cta').first().find('span').text();
              var subcategoryHTML =
              `<div class="form-subcategory option-selector pointer" data-subcategory="${i}" data-ticket-id="${v[1]}" data-subject="${v[2]}" data-type="${v[3]}" data-type-value="${v[4]}">
                  <div class="d-flex align-items-center w-100 p-2 p-md-3">
                      <span class="col ps-0 pe-4">${v[0]}</span>
                      <div class="option-selector-cta"><i class="fas fa-lg fa-angle-right"></i><span class="text-primary"><u>${changeText}</u></span></div>
                  </div>
              </div>`;
              $formSubcategoriesWrapper.append(subcategoryHTML);
          });

          $formSubcategories.slideDown();
      }

      function initalizeForm(category, subcategory) {
          formID = `${category}-${subcategory}`;

          $('.form-summary').html(formOptions[category][subcategory][5]);

          $formCategories.add($formSubcategoriesTitle).slideUp(400, function() {
              if (selectedCategory != 'Business') { $formFAQ.slideDown(); }
          });

          $('[data-related-to*="' + formID + '"]').show();

          if (($(document).width() < 992 && isMobile) || isExperience) { $formMain.slideDown().addClass('active'); }
          else { $formMain.show().addClass('active');
              $('.main-content').addClass('form-content');
          }

          formFieldsReset();

          // Prefill Hidden Fields
          $('#ticket_form_id').val($('.form-subcategory.active').attr('data-ticket-id'));
          $('#subject').val($('.form-subcategory.active').attr('data-subject'));

          if ($('.form-subcategory.active').attr('data-type') != '') {
              var $ticketType = $(`#${$('.form-subcategory.active').attr('data-type')}`);
              $ticketType.prop('disabled', false);
              $ticketType.val($('.form-subcategory.active').attr('data-type-value'));
          }

          // Form Selections
          if (selectedCategory == 'Product') {
              if (parseInt(selectedSubcategory) == 0) {
                  // I have a question about Secretlab products
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldFiles', false);
                  formFieldShow('fieldMessage', true, localization.message, true);
              } else if (parseInt(selectedSubcategory) == 1) {
                  // I would like to share feedback and recommendations for Secretlab's products
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldFiles', false);
                  formFieldShow('fieldMessage', true, localization.message, true);
              } else if (parseInt(selectedSubcategory) == 2) {
                  // I would like my personal data to be deleted
                  formFieldShow('fieldMessage', true, localization.message, true);
              } else if (parseInt(selectedSubcategory) == 3) {
                  // I have a question about Secretlab's Website Terms of Use/ Sale Terms
                  formFieldShow('fieldMessage', true, localization.message, true);
              }
          } else if (selectedCategory == 'Business') {
            if (parseInt(selectedSubcategory) == 3) {
                // I would like to make a bulk/corporate order
                $contactForm.hide();
                formFieldShow('redirectBulkOrder', false);
            } else {
              formFieldShow('fieldCompany', false);
              formFieldShow('fieldMessage', true, localization.message, true);
            }
          } else if (selectedCategory == 'Payment') {
              if (parseInt(selectedSubcategory) == 0) {
                  // I did not receive an order confirmation email
                  $('#fieldPurchaserLabels').hide();
                  $('#fieldPurchaserOptions, #purchaserOptionsWindow, #optionsDivider').show();
                  formFieldShow('fieldCustomerName', true);
                  formFieldShow('fieldCustomerEmail', true);
                  formFieldShow('fieldCustomerAddress', true);
                  formFieldShow('fieldOrderNumber', false);
                  formFieldShow('fieldMessage', false, localization.tell_us_anything, true);
              } else if (parseInt(selectedSubcategory) == 1) {
                  // I am unable to use my promotional/redemption code
                  $('#fieldFilesLabels > .dynamic-label').hide();
                  $('#fieldFilesLabels > .label-2').show();
                  formFieldShow('fieldPromoCode', true);
                  formFieldShow('fieldMessage', true, localization.tell_us_more, true);
                  formFieldShow('fieldFiles', true);
              } else if (parseInt(selectedSubcategory) == 2) {
                  // I am facing an error with completing payment
                  $('#fieldFilesLabels > .dynamic-label').hide();
                  $('#fieldFilesLabels > .label-2').show();
                  formFieldShow('fieldMessage', true, localization.tell_us_more, true);
                  formFieldShow('fieldFiles', true);
              } else if (parseInt(selectedSubcategory) == 3) {
                  // I would like the order invoice to be resent to me
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldMessage', false, localization.tell_us_anything, true);
              } else if (parseInt(selectedSubcategory) == 4) {
                  // I am eligible for VAT exemption and would like to apply for it
                  $('#vatDescriptor, #vatDivider').show();
                  formFieldShow('fieldContact', true);
                  formFieldShow('fieldCompany', true);
                  formFieldShow('fieldVAT', true);
                  formFieldShow('fieldBillingAddress', true);
                  formFieldShow('fieldShippingAddress', true);
                  formFieldShow('fieldState', true);
                  formFieldShow('fieldMessage', true, localization.order_example, true);
              }
          } else if (selectedCategory == 'Delivery') {
              if (parseInt(selectedSubcategory) == 0) {
                  // I would like to check on the delivery status of my order
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldMessage', false, localization.tell_us_anything);
              } else if (parseInt(selectedSubcategory) == 1) {
                  // I would like to add in a special delivery request for my order
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldMessage', true);
              } else if (parseInt(selectedSubcategory) == 2) {
                  // I would like to amend my shipping address
                  $('#fieldPurchaserLabels > .dynamic-label').hide();
                  $('#fieldPurchaserOptions, #fieldPurchaserLabels > .label-2').show();
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldCustomerName', false, "New Recipient's Name");
                  formFieldShow('fieldCustomerContact', false);
                  formFieldShow('fieldNewShippingAddress', true);
                  formFieldShow('fieldMessage', false, localization.tell_us_anything, true);
              } else if (parseInt(selectedSubcategory) == 3) {
                  // I have received my order and it was damaged upon arrival
                  $('#fieldPurchaserLabels > .dynamic-label, #fieldFilesLabels > .dynamic-label').hide();
                  $('#fieldPurchaserOptions, #fieldPurchaserLabels > .label-3, #fieldFilesLabels > .label-3, #serialNumbers').show();
                  formFieldShow('fieldCustomerAddress', false);
                  formFieldShow('fieldContact', true);
                  formFieldShow('fieldDeliveryDate', true);
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldChairSerial', true);
                  formFieldShow('fieldManualSerial', false);
                  formFieldShow('fieldMessage', true, localization.tell_us_more, true);
                  formFieldShow('fieldFiles', true);
              } else if (parseInt(selectedSubcategory) == 4) {
                  // My country is not in the list of available shipping zones, can I request for it to be added?
                  $contactForm.hide();
                  $('#redirectIntOrder').show();
              }
          } else if (selectedCategory == 'Warranty') {
              if (parseInt(selectedSubcategory) == 0) {
                  // I would like more information about the Warranty policy
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldMessage', true, localization.message, true);
              } else if (parseInt(selectedSubcategory) == 1) {
                  // I would like to make a warranty claim
                  $('#fieldPurchaserLabels > .dynamic-label, #fieldFilesLabels > .dynamic-label').hide();
                  $('#fieldPurchaserOptions, #fieldPurchaserLabels > .label-3, #fieldFilesLabels > .label-3, #serialNumbers').show();
                  formFieldShow('fieldCustomerAddress', false);
                  formFieldShow('fieldContact', true);
                  formFieldShow('fieldDeliveryDate', false);
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldChairSerial', true);
                  formFieldShow('fieldManualSerial', false);
                  formFieldShow('fieldMessage', true, localization.tell_us_more, true);
                  formFieldShow('fieldFiles', true);
              }
          } else if (selectedCategory == 'Refunds') {
              if (parseInt(selectedSubcategory) == 0) {
                  // I would like more information about the Return & Refund policy
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldMessage', true, localization.message, true);
              } else if (parseInt(selectedSubcategory) == 1) {
                  // I would like to cancel my order
                  $('#fieldPurchaserOptions').show();
                  formFieldShow('fieldPurchaserName', false);
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldMessage', true, localization.reason_for_cancel, true);
              } else if (parseInt(selectedSubcategory) == 2) {
                  // I would like to return my order for a refund
                  $('#fieldFilesLabels > .dynamic-label').hide();
                  $('#fieldFilesLabels > .label-4').show();
                  formFieldShow('fieldShippingAddress', true);
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldPackaging', true);
                  formFieldShow('fieldMessage', true, localization.reason_for_return, true);
                  formFieldShow('fieldFiles', true);
              } else if (parseInt(selectedSubcategory) == 3) {
                  // I would like to check on the status of a refund
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldMessage', true, localization.message, true);
              }
          } else if (selectedCategory == 'Promotions') {
              if (parseInt(selectedSubcategory) == 0) {
                  // I would like more information about the current promotions and offers
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldMessage', true, localization.message, true);
              } else if (parseInt(selectedSubcategory) == 1) {
                  // I would like more information about the Warranty Extension Program
                  $('#warrantyFAQ').show();
                  $contactForm.hide();
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldMessage', true, localization.message, true);
              } else if (parseInt(selectedSubcategory) == 2) {
                  // I would like more information about the Referral Program
                  $('#referralFAQ').show();
                  $contactForm.hide();
                  formFieldShow('fieldProductType', false);
                  formFieldShow('fieldOrderNumber', true);
                  formFieldShow('fieldMessage', true, localization.message, true);
              }
          }
      }

      function validateDatepicker() {
          $('.datepicker').each(function(){
              if ($(this).val() == '') {
                  $(this).addClass('is-invalid');
              } else {
                  $(this).removeClass('is-invalid');
              }
          });

      }

      function validateCheckbox() {
          var checkboxChecked = true;

          $('.input-checkbox[required]').each(function(){
              var $checkboxWrapper = $(this).parent('.checkbox__input');

              if (!$(this).is(':checked')) {
                  $checkboxWrapper.addClass('is-invalid');
                  $checkboxWrapper.siblings('.checkbox__label').addClass('is-invalid');
                  checkboxChecked = false;
              } else {
                  $checkboxWrapper.removeClass('is-invalid');
                  $checkboxWrapper.siblings('.checkbox__label').removeClass('is-invalid');
              }
          });

          if (checkboxChecked) {
              $('#wrapper_terms .invalid-feedback').hide();
          } else {
              $('#wrapper_terms .invalid-feedback').show();
          }
      }


      const serialno_regex = [
          "^([4-9][0-9])((0[0-9]|[0-4][0-9]|5[0-3])|(0[1-9]|10|11|12))(1[5-9]|2[0-9])([0-9]|[A-Za-z]|[0-9][A-Za-z]{1,2}|[A-C][A-Z])?$",
          "^([4-9][0-9])(-)?(1[5-9]|2[0-9])(-)?(?:\\d{3})(-)?([0-9]|TT|RB|RL|LL)?([A-Za-z]{3,4}|[0-9]{4})?(-)?([6-9])?([0-9]|[A-Za-z]|[0-9][A-Za-z]{1,2}|[A-C][A-Z])?$",
          "^([4-9][0-9])-(1[5-9]|2[0-9])(0[1-9]|10|11|12)(0[1-9]|[12]\d|3[01])-([A-Za-z]{3,4})([0-9]|[A-Za-z]|[0-9][A-Za-z]{1,2}|[A-C][A-Z])?$",
          "^([4-9][0-9])(1[5-9]|2[0-9])((0[0-9]|[0-4][0-9]|5[0-3])|(0[1-9]|10|11|12))([0-9]|[A-Za-z]|[0-9][A-Za-z]{1,2}|[A-C][A-Z])?$"
      ]

      function verify_warranty(serialno) {
          let result = false;

          serialno_regex.forEach((value, i) => {
                if (serialno.match(value)) {
                    result = true;
                }
            }
          )

          return result;
      }


      function validateSerialNo() {
          const $serialField = $('#serial_seatbase'),
              serialNo = $('#serial_seatbase').val(),
              $dailyBatch_field = $('#product_daily_batch_no'),
              $monthlyBatch_field = $('#production_line_serial_no');

          if(verify_warranty(serialNo)) {
              $dailyBatch_field.val('');
              $monthlyBatch_field.val(serialNo);
              $serialField.get(0).setCustomValidity('');
              $serialField.removeClass('is-invalid');
          } else {
              $serialField.get(0).setCustomValidity('Please provide a valid serial number.');
              $serialField.addClass('is-invalid');
          }
      }

      function validateAccessoriesSerialNo() {
          const $serialField = $('#production_line_serial_no_accessories'),
              serialNo = $('#production_line_serial_no_accessories').val();

          if(verify_warranty(serialNo)) {
              $serialField.get(0).setCustomValidity('');
              $serialField.removeClass('is-invalid');
          } else {
              $serialField.get(0).setCustomValidity('Please provide a valid serial number.');
              $serialField.addClass('is-invalid');
          }
      }

      function validateDescsription() {
          const $descriptionField = $('#description');
          const description = $descriptionField.val().trim();

          if(description.length > 0) {
              $descriptionField.get(0).setCustomValidity('');
              $descriptionField.removeClass('is-invalid');
          } else {
              $descriptionField.get(0).setCustomValidity('Please fill in the description.');
              $descriptionField.addClass('is-invalid');
          }
      }


      // EVENTS
      $('body').on('click', '.form-category', function(e) {
          var $formCategory = $('.form-category');
          var $that = $(this);

          e.preventDefault();

          if ($formCategoriesWrapper.hasClass('active')) {
              $formCategory.slideDown().add($formCategoriesWrapper).removeClass('active');
              $formSubcategories.slideUp();

              if (!isExperience) { history.pushState('', document.title, window.location.pathname + window.location.search); }
          } else {
              $('.main-content').removeClass('form-content');
              $formCategory.removeClass('active').not(this).slideUp();
              $that.add($formCategoriesWrapper).addClass('active');

              selectedCategory = $that.data('category');
              initalizeSubcategories(selectedCategory);

              if (!isExperience) { document.location.hash = selectedCategory?.toLowerCase(); }
          };
      });

      $('body').on('click', '.form-subcategory', function() {
          var $formSubcategory = $('.form-subcategory');
          var $that = $(this);

          if ($formSubcategoriesWrapper.hasClass('active')) {
              $formSubcategory.slideDown().add($formSubcategoriesWrapper).removeClass('active');
              $formCategories.add($formSubcategoriesTitle).slideDown();
              $formFAQ.slideUp();
              $formMain.hide().removeClass('active');
              $('.main-content').removeClass('form-content');
              if (!isExperience) { document.location.hash = selectedCategory?.toLowerCase(); }
          } else {
              $formSubcategory.removeClass('active').not(this).slideUp();
              $that.add($formSubcategoriesWrapper).addClass('active');

              selectedQuestion = $that.find('.col').text().trim();
              selectedSubcategory = $that.data('subcategory');
              initalizeForm(selectedCategory, selectedSubcategory);

              if (!isExperience) { document.location.hash = `${selectedCategory?.toLowerCase()}-${selectedSubcategory}`; }
          }
      });

      $('body').on('change', '#not_original_purchaser', function() {
          if ($(this).prop('checked')) {
              $('#purchaserOptionsWindow').slideDown();

              $('#purchaserOptionsWindow .form-group').each(function(){
                  if ($(this).is(':visible')) { $(this).find('.form-control').attr('required', true).prop('disabled', false).attr('placeholder', localization.required); }
              });
          } else {
              $('#purchaserOptionsWindow .form-control').attr('required', false).prop('disabled', true).attr('placeholder', '');
              $('#purchaserOptionsWindow').slideUp();
          }
      });

      $('body').on('click', '#referralContactForm, #warrantyContactForm', function(e) {
          e.preventDefault();
          $('#referralFAQ, #warrantyFAQ').slideUp();
          $contactForm.slideDown();
      });

      document.querySelector('.file-input').addEventListener('change', function (e) {
          var fileName = e.target.files[0] ? e.target.files[0].name : 'No file chosen';
          document.querySelector('.file-name').textContent = fileName;
      });


      function getAccessoriesInfoHtml (data)  {
          const {title, images, footer} = data;

          var displayInfoHtml = `
          <div id="accessories-data">
              <span style="font-size: 24px; font-weight: 700; margin-bottom: 25px; display: block;">
                  ${title}
              </span>
              <div class="d-flex">
                  <div class="me-sm-2">
                      <a href="${images[0]}" class="popup-image">
                          <img src="${images[0]}" class="img-fluid border rounded lazy lazy-fade" loading="lazy" style="opacity: 0;" onload="$(this).css(\'opacity\',\'1\');">
                      </a>
                  </div>
                  <div>
                      <a href="${images[1]}" class="popup-image">
                          <img src="${images[1]}" class="img-fluid border rounded lazy lazy-fade" loading="lazy" style="opacity: 0;" onload="$(this).css(\'opacity\',\'1\');">
                      </a>
                  </div>
              </div>
              <div class="mt-4">
                  ${footer}
              </div>
          </div>`;

          return displayInfoHtml;
      }

      function getMagnusAccessoriesInfoHtml (data)  {
          const {title, images, footer1, footer2} = data;

          var displayInfoHtml = `
          <div id="accessories-data">
              <span style="font-size: 24px; font-weight: 700; margin-bottom: 25px; display: block;">
                  ${title}
              </span>
              <div class="d-flex mb-4">
                  <div class="me-sm-2">
                      <a href="${images[0]}" class="popup-image">
                          <img src="${images[0]}" class="img-fluid border rounded lazy lazy-fade" style="opacity: 0;" onload="$(this).css(\'opacity\',\'1\');">
                      </a>
                  </div>
                  <div class="d-flex items-center	align-items-center">
                      <span>${footer1}</span>
                  </div>
              </div>
              <div class="d-flex">
                  <div class="me-sm-2">
                      <a href="${images[1]}" class="popup-image">
                          <img src="${images[1]}" class="img-fluid border rounded lazy lazy-fade" style="opacity: 0;" onload="$(this).css(\'opacity\',\'1\');">
                      </a>
                  </div>
                  <div>
                      <a href="${images[2]}" class="popup-image">
                          <img src="${images[2]}" class="img-fluid border rounded lazy lazy-fade" style="opacity: 0;" onload="$(this).css(\'opacity\',\'1\');">
                      </a>
                  </div>
              </div>
              <div class="mt-4">
                  ${footer2}
              </div>
          </div>`;

          return displayInfoHtml;
      }

      function getPremiumPCMountInfoHtml (data)  {
          const {title, images, footer1, footer2} = data;

          const displayInfoHtml = `
          <div id="accessories-data">
              <span style="font-size: 24px; font-weight: 700; margin-bottom: 25px; display: block;">
                  ${title}
              </span>
              <div class="d-flex mb-4">
                  <div class="me-sm-2">
                      <a href="${images[0]}" class="popup-image">
                          <img src="${images[0]}" class="img-fluid border rounded lazy lazy-fade" style="opacity: 0;" onload="$(this).css(\'opacity\',\'1\');">
                      </a>
                  </div>
                  <div class="d-flex items-center	text-center	align-items-center">
                  <a href="${images[1]}" class="popup-image">
                      <img src="${images[1]}" class="img-fluid border rounded lazy lazy-fade" style="opacity: 0;" onload="$(this).css(\'opacity\',\'1\');">
                  </a>
                  </div>
              </div>
              <div class="mt-4 mb-4">
                  ${footer1}
              </div>
              <div class="d-flex">
                  <div class="me-sm-2">
                      <a href="${images[1]}" class="popup-image">
                          <img src="${images[1]}" class="img-fluid border rounded lazy lazy-fade" style="opacity: 0;" onload="$(this).css(\'opacity\',\'1\');">
                      </a>
                  </div>
                  <div>
                      <a href="${images[2]}" class="popup-image">
                          <img src="${images[2]}" class="img-fluid border rounded lazy lazy-fade" style="opacity: 0;" onload="$(this).css(\'opacity\',\'1\');">
                      </a>
                  </div>
              </div>
              <div class="mt-4">
                  ${footer2}
              </div>
          </div>`;

          return displayInfoHtml;
      }

      $('body').on('click', '.product-accessories li', function(e) {
          e.preventDefault();
          $('.product-accessories .active').removeClass('active');
          $(this).addClass('active');
          let displayInfo = null;

          if ($(this).attr('id') == "magnus_shaped_extension") {
              displayInfo = getMagnusAccessoriesInfoHtml(accessoriesModal['magnus_shaped_extension']);
          } else if($(this).attr('id') == "premium_pc_mount") {
              displayInfo = getPremiumPCMountInfoHtml(accessoriesModal['premium_pc_mount']);
          } else {
              displayInfo = getAccessoriesInfoHtml(accessoriesModal[$(this).attr('id')]);
          }

          $("#accessories-data").remove();
          $('#accessories-wrapper').append(displayInfo);
      });

      $('body').on('change', 'input[name=product_type]', function(){
          if ((formID == 'Delivery-3') || (formID == 'Warranty-1')) {
              formFieldHide('fieldChairSerial');
              formFieldHide('fieldManualSerial');
              formFieldHide('fieldDeskSerial');
              formFieldHide('fieldDeskSerial2');
              formFieldHide('fieldNeueSerial');
              formFieldHide('fieldAccessoriesSerial');
              formFieldHide('fieldDeskMetalSerial');
              if (this.value == 'secretlab_chair') {
                  formFieldShow('fieldChairSerial', true);
                  formFieldShow('fieldManualSerial', false);
              } else if (this.value == 'magnus_pro') {
                  formFieldShow('fieldDeskSerial', true);
                  formFieldShow('fieldDeskSerial2', true);
              } else if (this.value == 'magnus_desk') {
                  formFieldShow('fieldDeskMetalSerial', true);
              } else if (this.value == 'neue_chair') {
                  formFieldShow('fieldNeueSerial', true);
              } else if (this.value == 'other_accessories') {
                  formFieldShow('fieldAccessoriesSerial', true);
              }
          }
      });

      $('#attachments').change(function() {
          var photo_max_size = 4000000, // 4MB
              video_max_size = 20000000, // 20MB
              total_max_size = 20000000, // 20MB
              number_of_files = this.files.length,
              file_name = this.files.length > 0 ? this.files[0].name : '',
              total_file_size = 0,
              $error = $('#attachments_error');

          $error.hide();

          if (/\.(jpe?g|png|mp4)$/i.test(file_name) === true) {
              if (number_of_files > 5) {
                  $error.text(localization.too_many_files).show();
                  $(this).val('');
              } else {
                  for (var i = 0; i <= (number_of_files - 1); i++) {
                      var this_file_size = this.files.item(i).size;

                      if (/\.(jpe?g|png)$/i.test(this.files.item(i).name) === true) {
                          // Check if image exceeds 4MB
                          if (this_file_size > photo_max_size) {
                              $error.text(localization.too_big_photo).show();
                              $(this).val('');
                              return;
                          }
                      } else {
                          // Check if video exceeds 20MB
                          if (this_file_size > video_max_size) {
                              $error.text(localization.too_big_video).show();
                              $(this).val('');
                              return;
                          }
                      }

                      total_file_size += this_file_size;

                      // Check if total file size exceeds 20MB
                      if (total_file_size > total_max_size) {
                          $error.text(localization.too_big_total).show();
                          $(this).val('');
                          return;
                      }
                  }
              }
          } else {
              $error.text(localization.invalid_file).show();
              $(this).val('');
          }
      });

      // Validation of form on submit btn click
      $submitBtn.on('click', function(e) {
          $contactForm.addClass('was-validated');

          if ($('#production_line_serial_no_desk_1').val().length > 0) {
              const firstBoxNo = $('#production_line_serial_no_desk_1').val();
              const secondBoxNo = $('#production_line_serial_no_desk_2').val();
              const combineBox = $('#production_line_serial_no_desk_two');
              combineBox.val(firstBoxNo + ',' + secondBoxNo);
          }

          if(!!$('.was-validated .form-control:invalid').length)
              $('html,body').animate({scrollTop: $('.was-validated .form-control:invalid').first().offset().top - ($('.nav-main').height() + 40)},'slow');

          if ($('#serial_seatbase').length > 0) { validateSerialNo(); }
          if ($('#production_line_serial_no_accessories').length > 0) { validateAccessoriesSerialNo(); }

          if ($('.datepicker[required="required"]').length > 0) { validateDatepicker(); }
          if ($('.input-checkbox[required]').length > 0) { validateCheckbox(); }

          // Validation of field on field change/keyup after form was validated
          $('body').on('change keyup', '#serial_seatbase', function(){
              validateSerialNo();
          }).on('change keyup', '#production_line_serial_no_accessories', function(){
              validateAccessoriesSerialNo();
          }).on('change keyup', '.datepicker[required="required"]', function(){
              validateDatepicker();
          }).on('change', '.input-checkbox[required]', function(){
              validateCheckbox();
          });

          if ($('#description[required]').length) validateDescsription();
      });

      $contactForm.on('submit', function(e) {
          e.preventDefault();
          responseHide();
          $contactForm.find('input, textarea, select').prop('readonly', true);
          $('#submit_spinner').removeClass('d-none');

          var formData = new FormData(this);
          // If Korea, get the checkboxes and add it to the formData
          if (isKorea) {
              var checkbox = $contactForm.find("input[type=checkbox]");
              $.each(checkbox, function(key, val) {
                  if($(val).is(':checked')) {
                      formData.set($(val).attr('name'), '1')
                  }
              });
          }

          // If there is a UID, send it as well, if not send null. For NFC experience page.
          if (getCookie('_exp_uid') != undefined) { formData.set('exp_uid', getCookie('_exp_uid')); }
          else { formData.set('exp_uid', null); }

          // Console Log Form Data
          // for (var pair of formData.entries()) {
          //     console.log(pair[0]+ ', ' + pair[1]);
          // }

          if (selectedCategory == 'Business') {
              // Old API (V3)
              // For Business Enquiries Only
              $.ajax({
                  type: "POST",
                  enctype: 'multipart/form-data',
                  url: "http://beans.secretlab.co/index.php/api/submit_contact_freshdesk",
                  data: formData,
                  processData: false,
                  contentType: false,
                  cache: false,
                  timeout: 60000,
                  dataType: "json",
              }).done(function(data){
                  responseSuccess();
                  clearFields();
              }).fail(function(response){
                  responseServerError();
                  console.log("ERROR: ", formID, response);
                  if ( typeof Sentry != 'undefined' ) {
                      Sentry.captureException(new Error('[SLE] Error occurred on Contact Form Business'));
                  }
              }).then(function(){
                  $contactForm.find('input, textarea').prop('readonly', false);
                  $('#submit_spinner').addClass('d-none');
              });
          } else {
              // New API (Zendesk)
              // Submit the form via AJAX
              $.ajax({
                  url: 'https://beans.secretlab.co/api/contact',
                  method: 'POST',
                  data: formData,
                  processData: false,
                  contentType: false,
                  cache: false
              }).done(function (data) {
                  if(data?.error == true) {
                      responseError();
                      console.log("ERROR: ", formID);
                      if ( typeof Sentry != 'undefined' ) {
                          Sentry.captureException(new Error('[SLE] Error occurred on Contact Form'));
                      }
                      return;
                  }
                  responseSuccess();
                  clearFields();

                  initalizeForm(selectedCategory, selectedSubcategory); // Reinitalize Form coz clear fields clear all required fields as well
              }).fail(function(response){
                  responseServerError();
                  console.log("ERROR: ", formID, JSON.stringify(response));
                  if ( typeof Sentry != 'undefined' ) {
                      Sentry.captureException(new Error('[SLE] Error occurred on Contact Form'));
                  }
              }).then(function(){
                  $contactForm.find('input, textarea').prop('readonly', false);
                  $('#submit_spinner').addClass('d-none');
              });
          }
      });
  });
});